exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove[data-v-39112296]{height:24px;width:24px;background-color:red;border-radius:50%;color:#fff;margin-left:4px;cursor:pointer}", ""]);

// exports
